<script>
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import QrReader from '@/vcs/_shared/QrReader.vue'
import { XIcon, EyeIcon } from 'vue-feather-icons'

export default {
  name: 'PhysicalQrReaderModal',
  components: { QrReader, XIcon, EyeIcon },
  extends: BaseModal,
  data: function () {
    return {
      qrInput: ''
    }
  },
  mounted() {
    this.$refs.input.focus()
  },
  methods: {
    processInputEvents(event) {
      const input = event.target
      this.$blockUI()

      if (event.data === '}') {
        window.clearTimeout(window.qrScanTimeout)
        this.$unblockUI()
        this.close(input.value)
        return
      }

      window.clearTimeout(window.qrScanTimeout)
      window.qrScanTimeout = setTimeout(() => {
        this.$unblockUI()
        this.close(input.value)
      }, 1000)
    },
    focusHiddenInput() {
      this.$refs.input.focus()
    }
  }
}
</script>

<template lang="pug">
span
  .modal-body(@click="focusHiddenInput")
    eye-icon.text-primary(size="4x")
    .text-primary Proszę zeskanować kod QR
    input(
      :class="{ 'col-hidden': !$isFrontex }"
      ref="input"
      @input="processInputEvents($event)"
      inputmode="none"
    )
</template>

<style lang="scss" scoped>
@import '@/assets/styles/mixins.scss';
.modal-body {
  overflow: hidden;
  font-size: 2rem;
  position: relative;
  text-align: center;

  input.col-hidden {
    position: fixed;
    left: 0;
    bottom: 0;
    opacity: 0;
    width: 0;
    overflow: hidden;
    padding: 0;
    margin: 0;
    height: 0;
  }
}
</style>
